import { Button, Grid, Popover } from "@material-ui/core";
import DataTable from "@saleor/changeOrder/components/DataSortTable";
import MyTypography from "@saleor/components/MyTypography";
import { useGetTransportationLazyQuery } from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import { FormikProps } from "formik";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface ModalAddressProps {
  onClose: () => void;
  visible: boolean;
  formik?: FormikProps<any>;
  anchorRef?: React.RefObject<HTMLButtonElement>;
}
export const useStyles = makeStyles(
  theme => ({
    dialogTitle: {
      textAlign: "left",
      padding: "0",
      display: "flex"
    },
    dialogTitleWrap: {
      height: "40px",
      display: " flex",
      alignItems: "center",
      lineHeight: "normal",
      marginBottom: "24px",
      marginTop: "0px"
    },
    transportWrapper: {
      maxHeight: "500px",
      overflowY: "auto"
    },
    btnWrapper: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: "15px"
    },
    mainTitle: {
      fontSize: "2rem",
      color: theme.palette.grey[900],
      fontWeight: 700
    },
    subTitle: {
      color: theme.palette.info.main,
      fontWeight: 400,
      fontSize: "1.6rem"
    },
    closeDialog: {
      cursor: "pointer"
    },
    searchPlantWrapper: {
      padding: "8px 16px 16px",
      minWidth: "384px",
      boxShadow: "0px 8px 24px 0px rgba(0, 0, 0, 0.24)",
      borderRadius: "12px"
    },
    buttonCancel: {
      height: "32px",
      border: "1px solid #222222",
      fontSize: "16px",
      borderRadius: "4px",
      color: "#222222",
      width: "100%",
      flex: "1",
      marginRight: "15px"
      // maxWidth: "168px"
    },
    buttonConfirm: {
      height: "32px",
      background: "#222222",
      fontSize: "16px",
      borderRadius: "4px",
      color: "#ffffff",
      width: "100%",
      flex: "1"
      // maxWidth: "168px"
    },
    root: {
      "& .MuiPaper-root": {
        maxWidth: 600,
        width: "100%",
        borderRadius: 12,
        padding: " 24px 32px"
      },
      "& .MuiDialogTitle-root": {
        padding: "0",
        display: "flex"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24
      },
      "& .MuiFormControlLabel-label": {
        fontSize: "1.4rem",
        lineHeight: "22px",
        color: theme.palette.grey[900]
      },
      "& .MuiRadio-root svg": {
        width: 18,
        height: 18
      }
    },
    detailTitle: {
      fontWeight: "bold",
      marginBottom: 10,
      "& .normalText": {
        fontWeight: "normal"
      }
    },
    dialogContent: {
      maxHeight: "calc(100% - 64px)",
      overflow: "auto",
      padding: "0 !important",
      "&::-webkit-scrollbar": {
        height: "34px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 20
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
    },
    labelRadio: {
      marginBottom: "2rem"
    },
    rowlength: {
      color: "#009FB8",
      fontFamily: "SCG",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "26px"
    },
    formControlLabel: {
      marginBottom: "2.5rem"
    },
    buttonAction: {
      width: "50%",
      height: 48
    },
    nameHead: {
      marginTop: 0,
      marginLeft: "12px",
      display: "flex !important",
      h2: {
        display: "flex !important"
      }
    },
    buttonWrap: {
      padding: "0px",
      marginTop: "24px"
    }
  }),
  { name: "ModalAddress" }
);

const ModalAddress: React.FC<ModalAddressProps> = props => {
  const { visible, onClose, formik, anchorRef } = props;

  const [transportCode, setTransportCode] = useState<string>("");
  const [transportName, setTransportName] = useState<string>("");
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "popover-id" : undefined;
  const classes = useStyles();
  const intl = useIntl();
  const columns = [
    { field: "Zone", headerName: "Zone", width: 90 },
    { field: "Description", headerName: "Description", width: 200 }
  ];
  const [
    getTransportation,
    { data: transportZoneCode }
  ] = useGetTransportationLazyQuery({
    fetchPolicy: "no-cache",
    variables: { countryCode: formik.values.countryCode }
  });

  useEffect(() => {
    if (visible) {
      getTransportation();
    }
  }, [visible]);
  const rows =
    transportZoneCode?.transportation?.map(transportCode => ({
      Zone: transportCode?.transportZoneCode,
      Description: transportCode?.transportZoneName
    })) || [];
  const dataRenderModal = {
    nameHead: intl.formatMessage({
      defaultMessage: "Transport Zone"
    })
  };

  const handleSubmit = () => {
    formik.setValues(prev => ({
      ...prev,
      transportZoneCode: transportCode,
      transportZoneName: transportName
    }));
    onClose();
  };
  const handleRowSelection = selectedRowIndex => {
    const selectedTransport = transportZoneCode?.transportation?.find(
      t => t.transportZoneCode === selectedRowIndex
    );
    if (selectedTransport?.countryCode) {
      setTransportCode(selectedTransport.transportZoneCode);
      setTransportName(selectedTransport.transportZoneName);
    }
  };
  return (
    <>
      <Popover
        id={id}
        open={visible}
        anchorEl={anchorRef?.current}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
      >
        <div
          className={classes.searchPlantWrapper}
          data-testid="modal-transport-content"
        >
          <MyTypography variant={"h6"} className={classes.nameHead}>
            {dataRenderModal?.nameHead}&nbsp;
            <span className={classes.rowlength}>({rows.length})</span>
          </MyTypography>

          <div className={classes.transportWrapper}>
            <Grid container>
              <Grid item xs={12} md={12}>
                <DataTable
                  selectedRow={transportCode}
                  setSelectedRow={setTransportCode}
                  onRowSelect={handleRowSelection}
                  headCells={columns}
                  rows={rows}
                  sortField="Zone"
                  boldFields={["Zone", "Description"]}
                />
              </Grid>
            </Grid>
          </div>

          <div className={classes.btnWrapper}>
            <Button
              id="closeButton"
              variant={"outlined"}
              color={"secondary"}
              className={classes.buttonCancel}
              onClick={onClose}
            >
              <FormattedMessage defaultMessage={"Cancel"} />
            </Button>
            <Button
              id="submitButton"
              variant={"contained"}
              color={"secondary"}
              className={classes.buttonConfirm}
              onClick={handleSubmit}
            >
              <FormattedMessage defaultMessage={"Submit"} />
            </Button>
          </div>
        </div>
      </Popover>
    </>
  );
};

ModalAddress.displayName = "ModalAddress";
export default ModalAddress;
